import styled from "styled-components";

// #####################################################

export const StyledModalAuthContentWrapper = styled.div`
	display: block;
	width: 100%;
	border: 1px solid #646464;
	border-radius: 1.75rem;
`;

// #####################################################
